import type { AppsTableRequestParamsDto } from "app/pages/sales-intelligence/modules/apps-search/types/dto";
import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";

import type { AppsSelectedRow } from "./types";

const createAppsSearchAction = createNamespacedAction("si/apps-search");

export const setAppsTableRequestParams =
    createAppsSearchAction<Partial<AppsTableRequestParamsDto>>("set-table-request-params");

export const resetAppsTablePagination = createAppsSearchAction<void>("reset-table-pagination");

export const setAppsIsRowSelectionEnabled = createAppsSearchAction<boolean>("set-is-row-selection-enabled");

export const setAppsSelectedRows = createAppsSearchAction<readonly AppsSelectedRow[]>("set-selected-rows");

export const setAppsSearchText = createAppsSearchAction<string>("set-search-text");
